/* eslint-disable no-console */

'use client';

import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import { useSession } from 'next-auth/react';
import { TabContext, TabList, TabPanel } from '@mui/lab';

import {
  CampaignCreatedModal,
  CampaignFormStepCreation,
  StyledTabItem,
  useBreadcrumbs,
  useCreateCampaign,
} from '~/entities';
import { ContentTitle, StyledContainer } from '~/shared';
import type { CreateCampaignDto } from '~/types';
import roles from '~/types/constants/roles';

export function NovaCampanhaView() {
  const breadcrumbs = useBreadcrumbs();
  const router = useRouter();
  const session = useSession();
  const role = session?.data?.user?.projects?.map(item => item?.roleName)[0];

  const [isAppCampaign, setIsAppCampaign] = useState(false);
  const [isWebCampaign, setIsWebCampaign] = useState(false);
  const [isCampaignCreated, setIsCampaignCreated] = useState<string | null>(
    null
  );

  const createCampaignMutation = useCreateCampaign(data => {
    setIsCampaignCreated(data.data.id);
  });

  function handleCreationStepContinue(createObject: CreateCampaignDto) {
    createCampaignMutation.mutate(createObject);
  }

  useEffect(() => {
    if (role === roles[0]) router.push('/campanhas');
  }, [role, router]);

  useEffect(() => {
    breadcrumbs.setPaths([
      { label: 'Campanhas', path: '/campanhas' },
      { label: 'Nova Campanha', path: '/campanhas/nova' },
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <ContentTitle title="Nova Campanha" />

      <StyledContainer>
        <TabContext value="1">
          <TabList variant="scrollable" scrollButtons allowScrollButtonsMobile>
            <StyledTabItem label="Dados de campanha" value="1" />
            <StyledTabItem label="Período e Segmentação" disabled />
            <StyledTabItem label="Formato - Web" disabled />
            <StyledTabItem label="Formato - App" disabled />
          </TabList>

          <TabPanel value="1">
            <CampaignFormStepCreation
              isWebCampaign={isWebCampaign}
              setIsWebCampaign={setIsWebCampaign}
              isAppCampaign={isAppCampaign}
              setIsAppCampaign={setIsAppCampaign}
              continueAction={handleCreationStepContinue}
              isLoadingAction={createCampaignMutation.isPending}
            />
          </TabPanel>
        </TabContext>
      </StyledContainer>

      {isCampaignCreated && <CampaignCreatedModal id={isCampaignCreated} />}
    </>
  );
}
